import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { formatSize } from "@lib/formatString";
import styles from "./styles/header.module.css";
export function Header({ selectedSize, handleCloseDrawer }) {
  const { t } = useTranslation("sizeguide");
  return (
    <header className={styles.header}>
      <h3 className={styles.title}>
        {t("size-guide")}: {formatSize(selectedSize.toUpperCase())}
      </h3>
      <a className={styles.close} onClick={handleCloseDrawer}>
        {t("close-size-guide")}
      </a>
    </header>
  );
}

Header.propTypes = {
  selectedSize: PropTypes.string.isRequired,
  handleCloseDrawer: PropTypes.func.isRequired,
};
